import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectSoldOut from './../../components/site/select_sold_out'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSoldOut: state.searchFormCondition.selectSoldOut,
})

const SelectSoldOutContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSoldOut)

export default SelectSoldOutContainer
